module.exports = __webpack_public_path__ + "img/Colorization8.ed266e5c.webp";